import React from "react";

import { Button } from "@blueprintjs/core";
import styles from "./ProductSidebarVariants.module.scss";
import { Icon } from "../../../atoms/Icon";
import VariantsTable from "./VariantsTable";

function ProductSidebarVariants({
  columns,
  rows,
  onChangeInput,
  addVariant,
  deleteVariant,
  addVariantOption,
  onChangeVariantOptionTitle,
  getVariantOptionTitle,
  deleteVariantOption,
  isValidatingForms,
  isFieldInvalid,
  duplicateSkuRowIndicies,
  duplicateOptionsRowIndices,
  duplicateTitleIndicies,
  allVariantOptionsHaveTitles,
  formHasAnInvalidPrice,
  minimumPrice,
  allVariantFieldsHaveValues: requiredFieldsHaveValues
}) {
  const somethingOnVariantsIsInvalid =
    !allVariantOptionsHaveTitles ||
    !requiredFieldsHaveValues ||
    !!duplicateSkuRowIndicies.length ||
    !!duplicateOptionsRowIndices.length ||
    !!formHasAnInvalidPrice;

  return (
    <div>
      {isValidatingForms && somethingOnVariantsIsInvalid && (
        <div className={styles.validationMessageContainer}>
          <Icon size={15} color="#ec7c7c" name="Exit-Circle" />
          <span className={styles.validationMessage}>
            {!requiredFieldsHaveValues || !allVariantOptionsHaveTitles
              ? "Highlighted Fields Required"
              : duplicateSkuRowIndicies.length
              ? "Not allowed to duplicate SKUs"
              : duplicateOptionsRowIndices.length
              ? "Not allowed to duplicate Variant Options"
              : "Minimum price is " + minimumPrice
            }
          </span>
        </div>
      )}

      <VariantsTable
        columns={columns}
        rows={rows}
        onChangeInput={onChangeInput}
        deleteVariant={deleteVariant}
        addVariantOption={addVariantOption}
        onChangeVariantOptionTitle={onChangeVariantOptionTitle}
        getVariantOptionTitle={getVariantOptionTitle}
        deleteVariantOption={deleteVariantOption}
        isValidatingForms={isValidatingForms}
        isFieldInvalid={isFieldInvalid}
        duplicateTitleIndicies={duplicateTitleIndicies}
      />

      <div className={styles.addVariantButton}>
        <Button
          icon={<Icon name="plus" size={14} />}
          className="bold"
          onClick={addVariant}
        >
          Add Variant
        </Button>
      </div>
    </div>
  );
}

export default ProductSidebarVariants;
